import { getJsonData } from '../api'
import { keys, get } from 'lodash'


const downloadCSV = (data, filename) => {
  let csvContent = "data:text/csv;charset=utf-8,";
  data.forEach((row, index) => {
    const dataString = row.join(",");
    csvContent += index < data.length ? dataString+ "\n" : dataString;
  })
  const encodedUri = encodeURI(csvContent);
  var link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", filename);
  link.click(); // This will download the data file named "my_data.csv".
}


const processData = (data, countries, indicators) => {
  let out = []
  countries.forEach(country => {
    indicators.forEach(indicator => {
      const cData = get(data[indicator], `[${country}]`, {});
      const years = keys(cData).sort()
      years.forEach(year => {
        const row = [country, indicator, year, get(cData[year], 'v')]
        out.push(row)
      })
    })
  })
  return out
}

const processDataTFAArticles = (data, countries, indicators) => {
  let out = []
  countries.forEach(country => {
    indicators.forEach(indicator => {
      const cData = get(data[indicator], `[${country}]`, {});
      const row = [country, `TFA Article ${indicator}` , get(cData, 'date'), get(cData, 'v')]
      out.push(row)
    })
  })
  return out
}

const processDataTFAProvisions = (data, countries, indicators) => {
  let out = []
  countries.forEach(country => {
    indicators.forEach(indicator => {
      const cData = get(data[indicator], `[${country}]`, {});
      const row = [country, `TFA Provision ${indicator}`, get(cData, 'date'), get(cData, 'v')]
      out.push(row)
    })
  })
  return out
}

export const getCsvFile = (filename, countries, indicators=[], articles=[], provisions=[]) => {
  // in the form (countryCode, indicatorCode, year, value)
  let out = [["countryCode", "indicator", "year", "value"]]
  return getJsonData("/data_by_indicator.json")
  .then(data => {
    out = out.concat(processData(data, countries, indicators))
    return getJsonData("/tfa/data_tfa_articles.json")
  })
  .then(data2 => {
    out = out.concat(processDataTFAArticles(data2, countries, articles))
    return getJsonData("/tfa/data_tfa_provisions.json")
  })
  .then(data3 => {
    out = out.concat(processDataTFAProvisions(data3, countries, provisions))
    return downloadCSV(out, filename)
  })
}



// WEBPACK FOOTER //
// ./src/utils/csvdownload.js